import { motion } from "framer-motion";

const MaskedLine = ({ children, delay }) => (
    <span className="block overflow-hidden pb-1">
        <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.span>
    </span>
);

export default function Intro() {
    return (
        <section id="o-tilio" data-testid="intro-section" className="px-6 pt-[110px] pb-20 md:pt-[142px] md:pb-28">
            <div className="text-center">
                <h1
                    data-testid="intro-headline"
                    className="font-serif leading-[1.08] tracking-[-0.3px] text-pine sm:whitespace-nowrap md:tracking-[-1.2px]"
                    style={{ fontSize: "clamp(1rem, 3.3vw, 3.75rem)" }}
                >
                    <MaskedLine delay={0.35}>
                        Tilio — domki nad <em className="not-italic">Liwcem</em>, około godziny od Warszawy
                    </MaskedLine>
                </h1>
                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.85, ease: [0.16, 1, 0.3, 1] }}
                    className="mx-auto mt-8 max-w-xl text-[17px] leading-[1.6] text-sage xl:max-w-none xl:whitespace-nowrap xl:text-lg"
                    data-testid="intro-copy"
                >
                    Całoroczne domki nad rzeką Liwiec w Sekłaku na Mazowszu, około godziny od Warszawy. Sauna, jacuzzi, prywatna działka i bezpośredni dostęp do rzeki.
                </motion.p>
            </div>
        </section>
    );
}
